<script lang="ts" setup>
  import { type HTMLAttributes, computed } from 'vue'
  import {
    RangeCalendarNext,
    type RangeCalendarNextProps,
    useForwardProps,
  } from 'radix-vue'
  import { ChevronRight } from 'lucide-vue-next'
  import { cn } from '@/lib/utils'
  import { buttonVariants } from '@/components/sm/shadcn/button'

  const props = defineProps<
    RangeCalendarNextProps & { class?: HTMLAttributes['class'] }
  >()

  const delegatedProps = computed(() => {
    const { class: _, ...delegated } = props

    return delegated
  })

  const forwardedProps = useForwardProps(delegatedProps)
</script>

<template>
  <RangeCalendarNext
    :class="
      cn(
        buttonVariants({ variant: 'outline' }),
        'bg-transparent h-7 w-7 rounded-full border-none p-0 opacity-50 hover:opacity-100',
        props.class
      )
    "
    v-bind="forwardedProps">
    <slot>
      <ChevronRight class="h-4 w-4" />
    </slot>
  </RangeCalendarNext>
</template>
